import { Component } from '@angular/core';
import { InstafeedComponent } from '../../components/instafeed/instafeed.component';

@Component({
  selector: 'app-gallery',
  imports: [InstafeedComponent],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
})
export class GalleryComponent {}
